import { render, staticRenderFns } from "./section-avatar-decoration.vue?vue&type=template&id=d622c406"
import script from "./section-avatar-decoration.vue?vue&type=script&lang=js"
export * from "./section-avatar-decoration.vue?vue&type=script&lang=js"
import style0 from "./section-avatar-decoration.vue?vue&type=style&index=0&id=d622c406&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0_gf3z3nxy4xzyghx7z43uzvzowq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports